import { Brick, Cache, Process, registerBrick } from 'olympe';
import {firstValueFrom} from "rxjs";

export default class FilterUnsavedAssessmentsWhenOffline extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Assessment[] | QueryResult<Assessment>} assessments
     * @param {function(Assessment[] | QueryResult<Assessment>)} setFilteredList
     */
    async update($, [assessments], [setFilteredList]) {
        // No need to listen to "is online" updates because a new list of assessments is retrieved as soon as we switch online/offline
        if (await firstValueFrom(Process.isOnline($))) {
            setFilteredList(assessments); // Do not change anything when online
            return;
        }

        const savedEntries = await firstValueFrom(Cache.getCacheEntries());
        const savedAssessments = savedEntries.reduce((assessments, entryName) => {
            const match = /^Assessment_([a-fA-F0-9]*)$/.exec(entryName);
            match && assessments.add(match[1]);
            return assessments;
        }, new Set());

        setFilteredList(assessments.filter((assessment) => savedAssessments.has(assessment.getTag())));
    }
}

registerBrick('018c8798b584fb757584', FilterUnsavedAssessmentsWhenOffline);
